import type { ComponentProps } from "react";

import { Badge } from "@/components/ui/badge";
import { cn } from "@/lib/utils";

export type StatusTone = "positive" | "warning" | "muted" | "neutral" | "outline" | "strong" | "danger";

const TONES: Record<StatusTone, { variant: ComponentProps<typeof Badge>["variant"]; className?: string }> = {
  positive: { variant: "outline", className: "bg-positive/10 text-positive border-transparent" },
  warning: { variant: "outline", className: "bg-warning/10 text-warning border-transparent" },
  muted: { variant: "outline", className: "text-muted-foreground" },
  neutral: { variant: "secondary" },
  outline: { variant: "outline" },
  strong: { variant: "default" },
  danger: { variant: "destructive" },
};

/** A record's lifecycle word in a pill; the tone says how it reads (running, waiting, done, failed). */
export function StatusPill({
  tone,
  className,
  ...props
}: Omit<ComponentProps<typeof Badge>, "variant"> & { tone: StatusTone }) {
  return <Badge variant={TONES[tone].variant} className={cn(TONES[tone].className, className)} {...props} />;
}
